import React, {useState, useEffect} from 'react';
import Autosuggest, {SuggestionsFetchRequestedParams} from 'react-autosuggest';
import {Field, useFormikContext} from 'formik';
import {apiClient} from "../../../utils/ApiClient";
import '../../common/form/css/ClientInput.css';
import {Option} from "../../common/form/ElogSelect";

interface FieldRenderProps {
    field: {
        name: string;
        value: string;
        onChange: (e: React.ChangeEvent<any>) => void;
        onBlur: () => void;
        onFocus: () => void;
    };
}

interface VendorInputProps {
    contacts?: Option[];
}

interface FormValues {
    vendor: string;
    // Add other form fields if needed
}

const VendorInput: React.FC<VendorInputProps> = ({contacts}: VendorInputProps) => {
    const formik = useFormikContext<any>();

    const [value, setValue] = useState<string>('');
    const [suggestions, setSuggestions] = useState<Option[]>([]);
    const [vendorContacts, setVendorContacts] = useState<Option[]>([]);

    useEffect(() => {
        if (contacts) {
            console.log('VendorContacts', contacts);
            fetchVendorContacts(formik.values.vendor);
        }
    }, [contacts]);

    const fetchVendors = async (inputValue: string) => {
        try {
            const apiResponse = await apiClient.get(`suggest/vendor?name=${encodeURIComponent(inputValue)}`);
            const vendors: Option[] = apiResponse.data.map((vendor: { id: number; name: string }) => ({
                label: vendor.name,
                value: vendor.id.toString(),
            }));
            console.log('Vendors', vendors);
            setSuggestions(vendors);
            fetchVendorContacts(inputValue);
        } catch (error) {
            console.error('Fetch vendors error:', error);
        }
    };

    const onSuggestionsFetchRequested = ({value}: SuggestionsFetchRequestedParams) => {
        if (value.length > 1) {
            fetchVendors(value);
        } else {
            setSuggestions([]);
        }
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    const onSuggestionSelected = (event: React.FormEvent<any>, {suggestion}: { suggestion: Option }) => {
        setValue(suggestion.label);
        fetchVendorContacts(suggestion.label);
    };

    const renderSuggestion = (suggestion: Option) => (
        <div>
            {suggestion.label}
        </div>
    );

    const fetchVendorContacts = async (selectedvendorName: string) => {

        if (!selectedvendorName) {
            return;
        }

        try {
            const apiResponse = await apiClient.get(`vendor-contacts/vendor?name=${encodeURIComponent(selectedvendorName)}`);
            const contacts: Option[] = apiResponse.data.map((contact: { id: number; name: string }) => ({
                label: contact.name,
                value: contact.id.toString(),
            }));

            const oldContacts = vendorContacts.map(contact => `${contact.value}-${contact.label}`).join(',');
            const newContacts = contacts.map(contact => `${contact.value}-${contact.label}`).join(',');

            if (newContacts !== oldContacts) {

                setVendorContacts(contacts);

                const selectedContactValue = formik?.values?.vendorContact?.[0];
                const isSelectedContactInNewContacts = contacts.some(contact => contact.value === selectedContactValue);

                if (contacts.length > 0 && !isSelectedContactInNewContacts) {
                    const newContact = contacts[0];
                    formik.setFieldValue('vendorContact', [newContact.value]);
                }

            }

        } catch (error) {
            console.error('Fetch vendor contacts error:', error);
        }
    };

    useEffect(() => {
        if (!formik?.values?.vendor) return;
        if (formik.values.vendor.length > 1) {
            fetchVendorContacts(formik.values.vendor);
        }
    }, [formik?.values?.vendor]);

    const addVendorContact = () => {
        if (vendorContacts.length > 0 && formik?.values?.vendorContact) {
            formik.setFieldValue('vendorContact', [...formik.values.vendorContact, vendorContacts[0].value]);
        }
    };

    return (
        <>
            <tr>
                <th>Hankija*:</th>
                <td>
                    <Field
                        name="vendor"
                        render={({field}: FieldRenderProps) => {
                            if (field.value !== value && vendorContacts.length < 1) {
                                fetchVendorContacts(field.value);
                            }

                            return (
                                <Autosuggest
                                    suggestions={suggestions}
                                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                                    onSuggestionSelected={onSuggestionSelected}
                                    getSuggestionValue={(suggestion: Option) => suggestion.label}
                                    renderSuggestion={renderSuggestion}
                                    inputProps={{
                                        ...field,
                                        value: field.value || value,
                                        onChange: (_, {newValue}) => {
                                            setValue(newValue);
                                            const event = {
                                                target: {
                                                    value: newValue,
                                                    name: field.name,
                                                },
                                                persist: () => {
                                                },
                                            };
                                            field.onChange(event as React.ChangeEvent<HTMLInputElement>);
                                        },
                                    }}
                                    theme={{
                                        container: 'react-autosuggest__container',
                                        suggestionsContainer: (suggestions.length > 0)
                                            ? 'react-autosuggest__suggestions-container visible'
                                            : 'react-autosuggest__suggestions-container',
                                        suggestionsList: 'react-autosuggest__suggestions-list',
                                        suggestion: 'react-autosuggest__suggestion',
                                        suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
                                    }}
                                />
                            )
                        }}
                    />
                </td>
            </tr>
            <tr>
                <th>Hankija kontakt*:</th>
                <td>
                    {formik?.values?.vendorContact && formik.values.vendorContact.map((contactId: string, index: number) => (
                        <Field
                            key={index}
                            name={`vendorContact[${index}]`}
                            render={({field}: { field: any }) => (
                                <>
                                    <select
                                        {...field}
                                        value={contactId}
                                        onChange={(event) => {
                                            const selectedValue = event.target.value;
                                            formik?.setFieldValue(`vendorContact[${index}]`, selectedValue);
                                        }}
                                    >
                                        <option value="" disabled>Vali kontaktisik</option>
                                        {vendorContacts.map((contactOption) => (
                                            <option key={contactOption.value} value={contactOption.value}>
                                                {contactOption.label}
                                            </option>
                                        ))}
                                    </select>
                                    {index > 0 && (
                                        <span
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: 20,
                                                color: 'red',
                                                paddingLeft: '10px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                const newContacts = formik?.values?.vendorContact?.filter((_: any, idx: number) => idx !== index);
                                                if (newContacts) {
                                                    formik.setFieldValue('vendorContact', newContacts);
                                                }
                                            }}
                                        >
                                            -
                                        </span>
                                    )}
                                    {index === 0 && (
                                        <span
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: 20,
                                                color: 'green',
                                                paddingLeft: '10px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={addVendorContact}
                                        >
                        +
                    </span>
                                    )}
                                    <br/>
                                </>
                            )}
                        />
                    ))}
                </td>
            </tr>
        </>
    );
};

export default VendorInput;